module.exports = __webpack_public_path__ + "static/media/BG2.14fa5355.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/BG2.png
// module id = 38
// module chunks = 0